export class StorageItem {
	key: string;
	value: any;
	expires: number;
	object: string;

	constructor(key: string, value: any, expires: number, object: string) {
		this.key = key;
		this.value = value;
		this.expires = expires;
		this.object = object;
	}

	/**
	 * Checks if the cached element has expired
	 * @return {boolean} [description]
	 */
	public isExpired(): boolean {
		return this.expires < Date.now();
	}
}
